import { wavesblue } from '@mentimeter/sfinx-themes';

export const WavesBlueBackground = wavesblue.background;
